import React from 'react';
import ParametroFlexService from '../../../../lib/api/parametroFlex/parametroFlexService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroFlex extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametroFlex()
    {
        return ParametroFlexService.obterExcel()
    }

    enviarParametrosEventGrid()
    {
        return ParametroFlexService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametroFlex}
                enviarExcelParametros={ParametroFlexService.salvarExcelParametroFlex}
                deletarExcelParametros={ParametroFlexService.deletarExcelParametroFlex}
                nomeDoArquivo='Parametro Flex'
            ></TemplateParametro>
        );
    }
}

export default ParametroFlex;